import React, { useState } from 'react';
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Modal from "react-modal";
import { createTestDriveActivationCode } from "@services/api";
import { toast } from 'react-toastify';

const ActivateTestDriveModal = ({ playgameHandler }) => {
    const modal = useModal();
    const [activationCode, setActivationCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleInputChange = (e) => {
        setActivationCode(e.target.value);
        setErrorMessage("");
    }

    const handleSubmit = async () => {
        if (activationCode) {
            const resp = await createTestDriveActivationCode(activationCode);
            if (resp.message) {
                toast.success(resp.message);
                modal.hide();
                setActivationCode('');
                setErrorMessage('');
                playgameHandler()
            } else if (resp.error) {
                toast.error(resp.error);
                setErrorMessage("Invalid Code");
            }
        } else {
            setErrorMessage("Please enter a activation code");
        }
    }

    const closeTournamentRuleHandler = () => {
        modal.hide();
    }

    return (
        <Modal
            isOpen={modal.visible}
            ariaHideApp={false}
            className="mymodal"
            onRequestClose={modal.hide}
        >
            <div className={`overflow-y-auto ${errorMessage ? 'max-h-[495px]' : 'max-h-[470px]'} h-full flex w-[520px] p-[16px] flex-col gap-[16px] rounded-[32px] bg-[#F1F1F1] [box-shadow:0px_4px_16px_0px_rgba(0,_0,_0,_0.15)]`}>
                <div className="flex justify-center px-[16px] py-[6px] rounded-[16px] text-center">
                    <p className='text-[#000] text-center text-[28px] not-italic font-bold leading-[normal] tracking-[-1.12px]'>Let's Go!</p>
                </div>
                <div className='w-full flex p-[24px] justify-center items-start gap-[24px] rounded-[16px] bg-[#FAFAFA]'>
                    <div className='w-full flex flex-col items-center gap-[12px]'>
                        <p className='text-[#000] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>Enter your Activation Code</p>
                        <div className='w-full flex flex-col items-center gap-[4px]'>
                            {errorMessage && (
                                <p className='text-[#C70039] text-center text-[14px] not-italic font-semibold leading-[normal] tracking-[-1.12px]'>{errorMessage}</p>
                            )}
                            <input
                                type="text"
                                className='w-[80%] px-[12px] py-[12px] rounded-[8px] border-[1px] border-[#ccc] text-center'
                                placeholder='Activation Code'
                                value={activationCode}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex p-[16px] flex-col gap-[16px] rounded-[16px] bg-[#FFF]">
                    <button className="flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#25BD66]" onClick={handleSubmit}>
                        <p className='text-[#FFF] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.38px]'>Submit</p>
                    </button>
                    {/* <button className="flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#25BD66]" onClick={playgameHandler}>
                        <p className='text-[#FFF] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.38px]'>Proceed without Activation Code</p>
                    </button> */}
                    <button className="flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#000]" onClick={closeTournamentRuleHandler}>
                        <p className='text-[#FFF] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.38px]'>Go back</p>
                    </button>
                </div>
            </div>
        </Modal >
    )
}

export default NiceModal.create(ActivateTestDriveModal);